import { cn } from '@/utils/styles';
import {
  FormItem,
  FormField,
  FormLabel,
  FormControl,
  FormMessage,
  useFormField,
  FormDescription,
} from '../Form';

import { Checkbox } from '../Checkbox';

export interface CheckboxFieldProps
  extends React.ComponentPropsWithRef<typeof Checkbox> {
  name: string;
  leftLabel?: boolean;
  label?: React.ReactNode;
  description?: React.ReactNode;
  variant?: 'default' | 'login';
}

export const CheckboxField = ({
  name,
  label,
  className,
  leftLabel,
  defaultValue,
  description,
  variant = 'default',
  ...rest
}: CheckboxFieldProps) => {
  const formField = useFormField();

  return (
    <FormField
      name={name}
      control={formField.control}
      render={({ field }) => (
        <FormItem>
          <div className={cn('flex flex-row items-center gap-2', className)}>
            <FormControl>
              <Checkbox
                {...rest}
                onCheckedChange={field.onChange}
                checked={field.value ?? defaultValue}
                className={cn(
                  variant === 'login' && [
                    'h-4 w-4 rounded-[2px] border-white/20 bg-white',
                    'data-[state=checked]:bg-white data-[state=checked]:border-white/20',
                    '[&_svg]:text-gray-500',
                  ],
                )}
              />
            </FormControl>

            <div
              className={cn(
                'flex flex-col gap-2 justify-center data-[left-label=true]:order-first',
                variant === 'login' && 'text-white',
              )}
              data-left-label={leftLabel}
            >
              {label && (
                <FormLabel
                  className={cn(
                    'typography-caption2',
                    variant === 'login' && 'text-white',
                  )}
                >
                  {label}
                </FormLabel>
              )}

              {description && <FormDescription>{description}</FormDescription>}
            </div>
          </div>

          <FormMessage />
        </FormItem>
      )}
    />
  );
};
